






































import Vue from 'vue';
import { mapGetters } from 'vuex';
import invoiceSettings from '@/merchant/settings/invoice-settings';
import PaidFeatureNotEnabled from '@/common/components/PaidFeatureNotEnabled.vue';

export default Vue.extend({
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  data() {
    return {
      title: 'Invoice Settings' as string,
    };
  },
  computed: {
    ...mapGetters(['isInvoicingEnabled']),
    settingRows(): any[] {
      return invoiceSettings;
    },
  },
  methods: {
  },
  components: {
    PaidFeatureNotEnabled,
  },
});

